import React from "react";
import { Space, Typography, Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

const { Text } = Typography;

export const HeaderPage = ({ onClickBack, title, backText }) => {
  return (
    <Space wrap className="content-header-profile" style={{ marginBottom: 20 }}>
      <Button type="text" icon={<ArrowLeftOutlined />} size="large" onClick={onClickBack}>
        {backText ?? "Voltar"}
      </Button>
      <Text strong style={{ fontSize: 20 }}>
        {title}
      </Text>
    </Space>
  );
};
